import { useLocation } from 'react-router-dom';

export type FlowType = 'Kit Keeper' | 'Keepr' | 'St Annes';

export const useFlow = (): FlowType => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const flowParam = searchParams.get('flow');

  if (flowParam === 'keepr') {
    localStorage.setItem('flow', 'Keepr');
    return 'Keepr';
  } else if (flowParam === 'kitkeeper') {
    localStorage.setItem('flow', 'Kit Keeper');
    return 'Kit Keeper';
  } else if (flowParam === 'stannes') {
    localStorage.setItem('flow', 'St Annes');
    return 'St Annes';
  }

  const storedFlow = localStorage.getItem('flow');
  if (storedFlow === 'Keepr') return 'Keepr';
  if (storedFlow === 'St Annes') return 'St Annes';
  return 'Kit Keeper';
};
